module.exports = __webpack_public_path__ + "static/media/speaker2020.0bc81bb5.png";